module.exports = __webpack_public_path__ + "img/525.67dc671b.jpg";